<template>
  <base-modal
    v-if="showProductModal"
    class="editing-product modal"
    @close="closeModals"
  >
    <template #heading>
      Your {{ softwareProduct.fallbackName }}
    </template>

    <div class="scroll-area">
      <edit-product-form
        ref="productForm"
        :product="softwareProduct"
        :support="supportAddon"
        :show-title="false"
        :hide-button="true"
        @submit="submit"
      />
    </div>

    <template #footer>
      <primary-button
        size="md"
        :disabled="loading"
        @click="$refs.productForm.validateAndSubmit()"
      >
        <i
          v-if="loading"
          class="fas fa-spin fa-spinner"
        />
        Continue
      </primary-button>
    </template>
  </base-modal>
</template>

<script>
import EditProductForm from "../includes/EditProductForm";
import {mapActions, mapGetters} from "vuex";
import Swal from "sweetalert2";
import BaseModal from "../../global/modals/BaseModal";
import PrimaryButton from "../../global/buttons/PrimaryButton";

export default {
  components: {
    PrimaryButton,
    BaseModal,
    EditProductForm,
  },
  emits: [
    'product-updated',
  ],
  data() {
    return {
      pricesHolder: false,
    }
  },
  computed: {
    ...mapGetters('stripeConnectDashboard', [
      'showProductModal',
      'products',
      'addons',
    ]),
    ...mapGetters('productManager', [
      'softwareProduct',
      'supportAddon',
      'loading',
    ]),
    ...mapGetters('addonManager', [
      'missingAddonPrices',
    ]),
  },
  methods: {
    ...mapActions('stripeConnectDashboard', [
      'closeModals',
      'manageAddons',
    ]),
    ...mapActions('productManager', [
      'updateProductAndSupportAddon',
      'setLoadingState',
    ]),
    submit() {
      this.setLoadingState(true);
      this.updateProductAndSupportAddon().then(() => {
        Swal.fire({
          icon: "success",
          title: "Success!",
          // TODO: Better messaging, just want to let users know they can leave and return.
          text: 'Your SEO software product was updated successfully.',
          didClose: () => {
            if (this.missingAddonPrices) {
              this.adviseUpdateAddons();
            }
          }
        });
        this.closeModals();
        this.$emit('product-updated');
        this.setLoadingState(false);
      })
    },
    adviseUpdateAddons() {
      Swal.fire({
        icon: "info",
        title: "Check your addons",
        text: `It looks like you've just enabled a new currency and/or billing period.
          Lets check your addons and make sure you've filled out all of your prices`,
        didClose: () => {
          this.pricesHolder = false;
          const {addons, products} = this;
          this.manageAddons({addons, products});
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
  button {
    margin-left: auto;
  }
  
  .scroll-area {
    padding: 0 .5rem;
  }
</style>
